import { downloadFile } from '@fabric-app/compat';
import { toast } from '../../store/alerts.js';
import { isTruthy } from '@fabric-app/utils/guards';

const useDownloadResource = (resource) => {
  return resource?.fileUrl ? async () => {
    if (!resource.fileUrl) {
      toast({
        content: "No file to download",
        id: "no-file-to-download"
      });
      return;
    }
    const title = [
      resource.name || "untitled file",
      resource.extension
    ].filter(isTruthy).join(".");
    const contentType = resource.mimeType || "application/octet-stream";
    await downloadFile(resource.fileUrl, title, contentType);
  } : void 0;
};

export { useDownloadResource };
//# sourceMappingURL=useDownloadResource.js.map
